var _rect, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "white",
    rx: 180,
    ry: 180
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 120C693.6 120 841.6 231.2 897.6 390.4C908.8 424 917.6 459.2 920 496H800C797.6 465.6 790.4 436.8 780.8 410.4C740.8 309.6 636.8 240 512 240C354.4 240 224 370.4 224 528C224 685.6 354.4 816 512 816C636.8 816 740.8 746.4 780.8 645.6C790.4 619.2 797.6 590.4 800 560H920C917.6 596.8 908.8 632 897.6 665.6C841.6 824.8 693.6 936 512 936C286.4 936 104 753.6 104 528C104 302.4 286.4 120 512 120Z",
    fill: "#101E43"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 528,
    r: 120,
    fill: "#FFDD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconSvg);
export default __webpack_public_path__ + "static/media/app-icon-svg.2a3287c8e171b0d2a81ec103e596583a.svg";
export { ForwardRef as ReactComponent };